import WebMercatorViewport from 'viewport-mercator-project';

interface GetOutletsCenterCoordinatesParams {
  outlets: AdaptedStore[];
  mapWidth: number;
  mapHeight: number;
}

export const getOutletsCenterCoordinates = (
  params: GetOutletsCenterCoordinatesParams,
) => {
  const { outlets, mapWidth, mapHeight } = params;

  const lat = outlets.map(outlet => outlet.address.geometry?.lat ?? 0);
  const lng = outlets.map(outlet => outlet.address.geometry?.lon ?? 0);

  if (lat.length === 0 || lng.length === 0) return null;

  const cornersLngLat: [[number, number], [number, number]] = [
    [Math.min(...lng), Math.min(...lat)],
    [Math.max(...lng), Math.max(...lat)],
  ];

  const viewport = new WebMercatorViewport({
    width: mapWidth,
    height: mapHeight,
  }).fitBounds(cornersLngLat, { padding: 50 });

  const { longitude, latitude, zoom } = viewport;

  return { longitude, latitude, zoom };
};
